export function calculateCompletion(weeks) {
  const totalWeeks = weeks.length;
  const weeksWithTopics = weeks.filter((week) => week.topic.length).length;

  return parseInt((100 * weeksWithTopics) / totalWeeks);
}
